import { TypographyVariantsOptions } from '@mui/material/styles';
import * as Colors from './colors';

export const typography: TypographyVariantsOptions = {
  fontFamily: [
    'ITCAvantGardePro',
    'Roboto',
    'sans-serif'
  ].join(','),
  fontSize: 16,

  h1: {
    fontSize: '36px',
    lineHeight: '44px',
    fontWeight: 500,
    color: Colors.White,
  },

  h2: {
    fontSize: '28px',
    lineHeight: '36px',
    fontWeight: 500,
    color: Colors.White,
  },

  h3: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: 500,
    color: Colors.White,
  },

  h4: {
    fontSize: '18px',
    lineHeight: '28px',
    fontWeight: 500,
    color: Colors.White,
  },

  h5: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 500,
    color: Colors.White,
  },

  h6: {
    fontSize: '14px',
    lineHeight: '22px',
    fontWeight: 500,
    color: Colors.White,
  },

  body1: {
    color: Colors.White,
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 300,
    letterSpacing: '0.15px',
  },

  body2: {
    color: Colors.LightGray,
    fontSize: '14px',
    lineHeight: '22px',
    fontWeight: 300,
    letterSpacing: '0.15px',
  },

  subtitle1: {
    color: Colors.White,
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 500,
  },

  subtitle2: {
    color: Colors.LightGray,
    fontSize: '14px',
    lineHeight: '22px',
    fontWeight: 500,
    letterSpacing: '0.15px',
  },

  caption: {
    color: Colors.LightGray,
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 300,
    letterSpacing: '0.15px',
  },

  overline: {
    color: Colors.TableHeaderText,
    fontSize: '12px',
    lineHeight: '20px',
    fontWeight: 500,
    letterSpacing: 0,
    textTransform: 'none',
  },

  button: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 500,
    letterSpacing: 0,
    textTransform: 'none',
  },
}
